import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-primary text-white mt-20" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-2xl font-display font-bold mb-4">Hotel Del Rio</h3>
            <p className="text-white/80">
              Hospitalidade premium em Conceição do Araguaia, Pará.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Links Rápidos</h4>
            <div className="space-y-2">
              <Link to="/rooms" className="block text-white/80 hover:text-white transition-colors">
                Quartos
              </Link>
              <Link to="/contact" className="block text-white/80 hover:text-white transition-colors">
                Contato
              </Link>
              <Link to="/policies" className="block text-white/80 hover:text-white transition-colors">
                Políticas
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contato</h4>
            <div className="space-y-2">
              <div className="flex items-center gap-2 text-white/80">
                <MapPin className="h-4 w-4" />
                <span>Conceição do Araguaia - PA</span>
              </div>
              <div className="flex items-center gap-2 text-white/80">
                <Phone className="h-4 w-4" />
                <span>+55 94 99201-3575</span>
              </div>
              <div className="flex items-center gap-2 text-white/80">
                <Mail className="h-4 w-4" />
                <span>contato@hoteldelrio.com</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-8 text-center text-white/60 text-sm">
          <p>&copy; {new Date().getFullYear()} Hotel Del Rio. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};
